export default __webpack_public_path__ + "static/media/vector.d9c0112a.svg";